module.exports = __webpack_public_path__ + "img/1.26e3653e.png";